import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useParams } from "react-router-dom";
import { MessageView } from "./MessageView";
export function MessagePage() {
    const { backupId = "", itemId = "" } = useParams();
    return (_jsxs("div", { className: "max-w-4xl", children: [_jsx(Link, { to: `/backups/${backupId}/mail`, className: "text-xs text-slate-500 hover:underline", children: "\u2190 \u00EEnapoi la inbox" }), _jsx("div", { className: "mt-3", children: _jsx(MessageView, { backupId: backupId, itemId: itemId }) })] }));
}
